var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 22.6719H3.1665",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 28V18.6667C29.8332 17.1939 28.6393 16 27.1665 16H5.83317C4.36041 16 3.1665 17.1939 3.1665 18.6667V28",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16652 16L5.1665 8.67289C5.1665 8.30471 5.46498 8.00623 5.83317 8.00623H8.27085C9.26268 8.00623 10.1463 7.42992 10.7941 6.67887C11.9043 5.39173 13.7461 4.13628 16.4923 4C19.2251 4.12097 21.0842 5.38664 22.2036 6.68028C22.8526 7.43031 23.7371 8.00623 24.7289 8.00623H27.1665C27.5348 8.00623 27.8332 8.30471 27.8332 8.67289V16",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8332 16V13.7453C21.8332 13.4928 21.6912 13.2628 21.4597 13.1617C20.635 12.8016 18.5674 12 16.4998 12C14.4322 12 12.3646 12.8016 11.54 13.1617C11.3086 13.2628 11.1665 13.4928 11.1665 13.7453V16",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.1ce93fc514bc49203f1a9ef02171a1a1.svg";
export { ForwardRef as ReactComponent };